import "./NotFound.css"
import React from "react"
import locale from "../../localization/locale"

const Index = () => {
    return (
        <div className="page notFound">
            <div className="notfoundTitleNumber">404</div>
            <h1 className="notfoundTitleText">
                {locale.get("not_found")}
            </h1>
        </div>
    )
};

export default Index
